import React,{useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import { BASE_URL } from '../Config/Base';
import axios from 'axios';

const DepartmentMain = () => {


    useEffect(()=>{
        GetDept()
      
      },[])



    const [allusers1,setAllusers1]= useState([])
    const [Department,SetDepartment]= useState([])

    function GetDept(){
     
      
          fetch(`https://localhost:44326/api/OatTask/Getdepartment`,{
      
            method:"GET",
            headers:{
              "Content-type": "application/json",
      
              "Accept": "application/json",
        
             
        
              "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
            },
               //body:JSON.stringify(data)
      
          }).then(response=> response.json())
          .then(data=>{
            console.log("Data",data)
            setAllusers1(data)
            
          });
          console.log("check",allusers1)
        }
      
      function handledepartment(){

       var Department = document.getElementById("department").value


       const body =
  {
    
    department:Department
  }
  console.log('body',body);


  axios({
         method:"POST",
         url :`https://localhost:44326/api/OatTask/Selectdepartment`,
         data:body, 
         headers: {
                "Content-type": "application/json"
            
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
   
        SetDepartment(response.data);

    
     })
     .catch(error => {
       console.log(error);
       
     })

      }


  return (
    <div>

        <div class="container">
    <form action="action_page.php">
      <div class="row">
        <div class="col-25">
          {/* <label for="fname">First Name</label> */}
        </div>
        <div class="col-75">
            
        <select  name="Department" onInputCapture={handledepartment} className="form-select"   id="department" >
<option>Department</option>
        {allusers1.map((e)=>{
      return<option  value={e.department}>{e.department}</option>})}

{/* <option value="02">Team mate</option> */}

{/* {Roletable.map((e)=>
   {
     return<option value={e.role}>{e.role}</option> })} */}
                

</select>    
        </div>

        <br></br> <br></br><br></br> <br></br>


        <div class="col-75">
            
            <select  name="Department"  className="form-select"   id="role" >
              <option>TrainerName</option>
            {Department.map((e)=>{
      return<option value={e.trainerName}>{e.trainerName}</option>})}
            {/* {allusers1.map((e)=>{
          return<option  value=""></option>})} */}
          </select> 
    

      </div>
      </div>
      </form>

      </div>

      </div>
     
  )
}

export default DepartmentMain